import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { DropLocation } from "../drop.types";
import { getRankHoverBorderClass } from "../dropRankStyles";
interface ParticipationDropContainerProps {
  readonly drop: ExtendedDrop;
  readonly isActiveDrop: boolean;
  readonly location: DropLocation;
  readonly children: React.ReactNode;
}
const ACTIVE_DROP_STYLES = "tw-border tw-border-[#3CCB7F]/45 tw-shadow-[0_0_0_1px_rgba(60,203,127,0.14)]";
const getDropStyles = ({
  isActiveDrop,
  rank,
  isDrop
}: {
  isActiveDrop: boolean;
  rank: number | null;
  isDrop: boolean;
}): string => {
  if (!isDrop) {
    return "";
  }
  if (isActiveDrop) {
    return ACTIVE_DROP_STYLES;
  }
  if (rank === null) {
    return "tw-border tw-border-iron-800 desktop-hover:hover:tw-border-iron-600";
  }
  switch (rank) {
    case 1:
      return `tw-border tw-border-iron-800 ${getRankHoverBorderClass(1)}`;
    case 2:
      return `tw-border tw-border-iron-800 ${getRankHoverBorderClass(2)}`;
    case 3:
      return `tw-border tw-border-iron-800 ${getRankHoverBorderClass(3)}`;
  }
  return "tw-border tw-border-iron-800 desktop-hover:hover:tw-border-iron-700";
};
const getBackgroundClass = ({
  isActiveDrop
}: {
  isActiveDrop: boolean;
}): string => {
  if (isActiveDrop) {
    return "tw-bg-[#3CCB7F]/10";
  }
  return "tw-bg-iron-950";
};
export default function ParticipationDropContainer(t0) {
  const $ = _c(12);
  const {
    drop,
    isActiveDrop,
    location,
    children
  } = t0;
  const isDrop = drop.drop_type === ApiDropType.Participatory;
  let t1;
  if ($[0] !== drop.rank || $[1] !== isActiveDrop || $[2] !== isDrop) {
    t1 = getDropStyles({
      isActiveDrop,
      rank: drop.rank,
      isDrop
    });
    $[0] = drop.rank;
    $[1] = isActiveDrop;
    $[2] = isDrop;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const dropStyles = t1;
  let t2;
  if ($[4] !== isActiveDrop) {
    t2 = getBackgroundClass({
      isActiveDrop
    });
    $[4] = isActiveDrop;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const backgroundClass = t2;
  const t3 = `${location === DropLocation.WAVE ? "tw-px-4 tw-py-1" : ""} tw-w-full`;
  const t4 = `tw-group tw-relative tw-flex tw-w-full tw-flex-col tw-overflow-hidden tw-rounded-xl ${backgroundClass} ${dropStyles} tw-border-solid tw-transition-[box-shadow,background-color,border-color] tw-duration-200 tw-ease-out`;
  let t5;
  if ($[6] !== children || $[7] !== t4) {
    t5 = <div className={t4}>{children}</div>;
    $[6] = children;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}